// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    font-family: 'Nunito Sans', Sans-serif, serif;
    background-color: #ffffff;
}

#app-logo {
    width: 250px;
    height: auto;
}

.top-navigator-bar {
    height: 100px;
    width: 100%;
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    margin-top: 20px;
}

.title-banner {
    width: 15%;
    color: #f9f9f9;
    display: inline-flex;
    align-items: center;
    margin-left: 2%;
}

.mobile-container {
    display: none;
}

.navigators {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 5%;
}

.navigators span {
    width: auto;
    padding: 0 10px 0 10px;
    font-size: 18px;
    border-color: transparent;
    cursor: pointer;
}

.login-container {
    display: flex;
    align-items: center;
}

.login-container span, .mobile-container span {
    padding: 0;
    text-wrap: nowrap;
}

@media screen and (max-width: 650px) {
    #app-logo {
        width: 200px;
    }

    .top-navigator-bar {
        height: auto;
        align-items: flex-start;
    }

    .navigators {
        display: none;
    }

    .mobile-navigation-menu {
        display: flex;
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.90);
        position: fixed;
        z-index: 12;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .mobile-navigation-menu span, .mobile-navigation-menu button {
        color: #9e9e9e;
        font-size: 24px;
        margin: 12px 0;
    }

    .mobile-navigation-menu i {
        margin-top: 20px;
        color: #ffffff;
        font-size: 40px;
    }

    .title-banner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 5%;
    }

    .mobile-container {
        display: flex;
        align-items: center;
    }
}

@media screen and (max-width: 1150px) {
    .top-navigator-bar {
        margin-top: 0;
        flex-wrap: wrap;
    }

    .navigators {
        justify-content: flex-start;
        margin-left: 5%;
    }
}`, "",{"version":3,"sources":["webpack://./src/home/css/top-nav-bar.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,YAAY;QACZ,qCAAqC;QACrC,eAAe;QACf,WAAW;QACX,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;IACnB;AACJ","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    font-family: 'Nunito Sans', Sans-serif, serif;\n    background-color: #ffffff;\n}\n\n#app-logo {\n    width: 250px;\n    height: auto;\n}\n\n.top-navigator-bar {\n    height: 100px;\n    width: 100%;\n    align-items: center;\n    display: flex;\n    flex-wrap: nowrap;\n    margin-top: 20px;\n}\n\n.title-banner {\n    width: 15%;\n    color: #f9f9f9;\n    display: inline-flex;\n    align-items: center;\n    margin-left: 2%;\n}\n\n.mobile-container {\n    display: none;\n}\n\n.navigators {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-right: 5%;\n}\n\n.navigators span {\n    width: auto;\n    padding: 0 10px 0 10px;\n    font-size: 18px;\n    border-color: transparent;\n    cursor: pointer;\n}\n\n.login-container {\n    display: flex;\n    align-items: center;\n}\n\n.login-container span, .mobile-container span {\n    padding: 0;\n    text-wrap: nowrap;\n}\n\n@media screen and (max-width: 650px) {\n    #app-logo {\n        width: 200px;\n    }\n\n    .top-navigator-bar {\n        height: auto;\n        align-items: flex-start;\n    }\n\n    .navigators {\n        display: none;\n    }\n\n    .mobile-navigation-menu {\n        display: flex;\n        height: 100vh;\n        width: 100vw;\n        background-color: rgba(0, 0, 0, 0.90);\n        position: fixed;\n        z-index: 12;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .mobile-navigation-menu span, .mobile-navigation-menu button {\n        color: #9e9e9e;\n        font-size: 24px;\n        margin: 12px 0;\n    }\n\n    .mobile-navigation-menu i {\n        margin-top: 20px;\n        color: #ffffff;\n        font-size: 40px;\n    }\n\n    .title-banner {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-right: 5%;\n    }\n\n    .mobile-container {\n        display: flex;\n        align-items: center;\n    }\n}\n\n@media screen and (max-width: 1150px) {\n    .top-navigator-bar {\n        margin-top: 0;\n        flex-wrap: wrap;\n    }\n\n    .navigators {\n        justify-content: flex-start;\n        margin-left: 5%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
